module.exports = __webpack_public_path__ + "img/image-02.8c3d4ea6.webp";